<script setup lang="ts">
import Icon from '@components/Icon.vue';
import {
  IconBuildings,
  IconSlidersFill,
  IconUsers,
  IconMapPin,
  IconCoins,
  IconRuler,
} from '@icons';
import MobileFilterButton from '@pages/search/components/filters/MobileFilterButton.vue';
import { FilterType } from '@enums/FilterType.ts';
</script>

<template>
  <MobileFilterButton :type="FilterType.LOCATION">
    <template #icon>
      <Icon
        :svg="IconMapPin"
        width="24"
        height="24"
        fill="gray-dark"
      />
    </template>
  </MobileFilterButton>

  <MobileFilterButton :type="FilterType.CAPACITY">
    <template #icon>
      <Icon
        :svg="IconUsers"
        width="24"
        height="24"
        fill="gray-dark"
      />
    </template>
  </MobileFilterButton>

  <MobileFilterButton :type="FilterType.OFFICE_TYPE">
    <template #icon>
      <Icon
        :svg="IconBuildings"
        width="24"
        height="24"
        fill="gray-dark"
      />
    </template>
  </MobileFilterButton>

  <MobileFilterButton :type="FilterType.BUDGET">
    <template #icon>
      <Icon
        :svg="IconCoins"
        width="24"
        height="24"
        fill="gray-dark"
      />
    </template>
  </MobileFilterButton>

  <MobileFilterButton :type="FilterType.SURFACE">
    <template #icon>
      <Icon
        :svg="IconRuler"
        width="24"
        height="24"
        fill="gray-dark"
      />
    </template>
  </MobileFilterButton>

  <MobileFilterButton :type="FilterType.OTHER_FILTERS">
    <template #icon>
      <Icon
        :svg="IconSlidersFill"
        width="24"
        height="24"
        fill="gray-dark"
      />
    </template>
  </MobileFilterButton>
</template>
